import customersApi from '@/api/customers';

const specificationsFilters = [
  {
    name: 'customerId',
    label: 'customerIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const customersResponse = await customersApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = customersResponse.data.map((c) => ({
        label: `${c.id} ${c.name}`,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'customerProductCode',
    label: 'productCode',
    type: 'text',
    whereOperator: 'regexp',
  },
];

export default specificationsFilters;
